import { useState } from 'react';
import useListFetch, { UseListFetchProps } from '../../common/useListFetch';
import { AppConfig } from '../../AppConfig';
import CmonStatService from '../../services/cmon/CmonStatService';
export type UseQMTopQueriesListProps = Omit<UseListFetchProps, 'fetchFn'> & {
    pageSize?: number;
    clusterId: number;
};

export default function useQMTopQueriesList({
    pageSize = AppConfig.defaultPaginationConfig.pageSize,
    useCache,
    filters,
    name,
    clusterId,
}: UseQMTopQueriesListProps) {
    const [totalExecTime, setTotalExecTime] = useState(0);
    const {
        list: topQueries,
        loading,
        refresh,
        page,
        pageSize: listPageSize,
        total,
    } = useListFetch({
        name: 'qm-top-queries-list',
        pageSize,
        fetchFn: async ({ pageSize, page, sort, order, ...rest }, opts) => {
            const { data, total } = await CmonStatService.qm_topqueries(
                {
                    cluster_id: clusterId,
                    limit: pageSize,
                    offset: ((page || 1) - 1) * pageSize,
                    order_by_col: sort,
                    sortOrder:
                        order === 'ascend'
                            ? 'asc'
                            : order === 'descend'
                            ? 'desc'
                            : undefined,
                    ...rest,
                },
                opts
            );

            setTotalExecTime(data.total_query_exec_time_us);
            return {
                list: data,
                total,
            };
        },
        cancelFn: async ({ requestId }) => {
            await CmonStatService.cancelRequest(requestId);
        },
    });

    const list: any[] = topQueries;
    return {
        list,
        loading,
        refresh,
        page,
        pageSize: listPageSize,
        total,
        totalExecTime,
    };
}
